import { render, staticRenderFns } from "./ResultDisplay.vue?vue&type=template&id=3255019f&scoped=true&"
import script from "./ResultDisplay.vue?vue&type=script&lang=js&"
export * from "./ResultDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ResultDisplay.vue?vue&type=style&index=0&id=3255019f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3255019f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
